import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import DataTable from "react-data-table-component";
import { Table } from "react-bootstrap";
import { InputField } from "../../../../Components/formElements/InputField";

const ProductMatrixEditMaterialModal = React.forwardRef((props, ref) => {
 
  const washAndCare = {
    instructions: [
      { type: "Temperature", description: "Wash at 40°C" },
      { type: "Bleach", description: "Do not bleach" },
      { type: "Tumble dry", description: "Do not tumble dry" },
      { type: "Iron", description: "Iron warm (max 150°C)" },
      { type: "Dry clean", description: "Dry clean P" },
      { type: "Generic", description: "Line drip dry" },
    ],
    icons: [
      "bi-moisture",
      "bi-trash2-fill",
      "bi-recycle"
    ],
    productImages: [
      "assets/img/product_img/P01.png",
      "assets/img/product_img/P02.png",
      "assets/img/product_img/P03.png",
      "assets/img/product_img/P04.png",
      "assets/img/product_img/P05.png",
      "assets/img/product_img/P06.png"
    ],
  };

  let productDetailsCol = [
    {
      name: "Sl.No",
      selector: (row) => row.local_id || "--",
      cell: (row) => <>{row.local_id}.</>,
      sortable: true,
      width: "80px",
    },

    {
      name: "Type",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="type"
          placeholder=""
          value={row.type || ""}
          // onChange={(event) => handleInputChange(row.id, "type", event.target.value)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Account Code",
      selector: (row) => row.accountcode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="accountcode"
          placeholder=""
          value={row.accountcode || ""}
          // onChange={(event) => handleInputChange(row.id, "accountcode", event.target.value)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Account Relation",
      selector: (row) => row.accountRelation || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="accountRelation"
          placeholder=""
          value={row.accountRelation || ""}
          // onChange={(event) => handleInputChange(row.id, "accountRelation", event.target.value)}

          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Item Code",
      selector: (row) => row.itemCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemCode"
          placeholder=""
          value={row.itemCode || ""}
          // onChange={(event) => handleInputChange(row.id, "itemCode", event.target.value)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Item Reation",
      selector: (row) => row.itemRelation || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemRelation"
          placeholder=""
          value={row.itemRelation || ""}
          // onChange={(event) => handleInputChange(row.id, "itemRelation", event.target.value)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Instruction",
      selector: (row) => row.instruction || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="instruction"
          placeholder=""
          value={row.instruction || ""}
          // onChange={(event) => handleInputChange(row.id, "instruction", event.target.value)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.description || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="description"
          placeholder=""
          value={row.description || ""}
          // onChange={(event) => handleInputChange(row.id, "description", event.target.value)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
   
  ];

  const [getProductDetailsData, setProductDetailsData] = useState();

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [getShowFailureModal, setShowFailureModal] = useState(false);

  const [getErrorFields, /* setErrorFields*/] = useState([]);

  const [validation, /*setValidation*/] = useState({
    driverName: "",
  });

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const onInputChange = (e) => {
    const { name, value } = e.target;
    setFormInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [formInputs, setFormInputs] = useState();
  // SAVE
  const loadFirstLevelData = async () => {
    const productDetails = [
      {
    id: 1,
    local_id: 1,
    type: "Hired",
    accountcode: "CL001",
    accountRelation: "Apparel Department",
    itemCode: "TSHIRT001",
    itemRelation: "Men's Wear",
    instruction: "Dry clean only",
    description: "Cotton T-shirt with printed design"
  },
  {
    id: 1748081810268,
    local_id: 2,
    type: "Hired",
    accountcode: "CL002",
    accountRelation: "Fashion Division",
    itemCode: "JACKET002",
    itemRelation: "Winter Collection",
    instruction: "Do not machine wash",
    description: "Woolen jacket for cold weather"
  },
  {
    id: 1748081810545,
    local_id: 3,
    type: "Hired",
    accountcode: "CL003",
    accountRelation: "Sportswear Division",
    itemCode: "TRACKP003",
    itemRelation: "Athletic Gear",
    instruction: "Wash with similar colors",
    description: "Polyester track pants for training"
  }
    ]
    setProductDetailsData(productDetails)

    const productFormData = {
      identification: "Yes",
      itemNumber: "CP320102",
      product: "Casual Polo T-Shirt",
      productType: "Apparel",
      productSubType: "T-Shirt",
      retailCategory: "Men's Clothing",
      porductBrands: "CasualPolo",
      purchase: "1200.00",
      inventory: "500.00",
      sales: "549.00",
      recomended: "600.00",
      washAndCare: washAndCare,
      productDetails: productDetails
    };
    setFormInputs(productFormData)



  };
  console.log(">>formInputs", formInputs)

  useEffect(() => {
    loadFirstLevelData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  // eslint-disable-next-line no-unused-vars
  const navigateToLogin = () => {
    // navigate(Constants.LOGIN);
  };
  // console.log(">>props",props)
  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {/* <i className="bi bi-plus-lg"></i>  */}
          Product Matrix Details
          {/* <p className="subText">
            At supplier_app, every person has a role, each with its own level of
            access.
          </p> */}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
     
        <Row>
          <Col xs={12} md={9} lg={9}>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">320102: Casualpolo </span>
                      <span className="subHeaderTitle">Product Matrix - Product 320102 - Casual Polo(View)</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible1 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Identification"
                          name="identification"
                          placeholder=""
                          value={formInputs?.identification || ""}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                      {/* {formInputs?.identification === "Yes" && ( */}
                      <>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Item Number"
                            name="itemNumber"
                            placeholder=""
                            value={formInputs?.itemNumber || ""}
                            onChange={onInputChange}
                            error={validation.itemNumber}
                            required={true}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Product"
                            name="product"
                            placeholder=""
                            value={formInputs?.product || ""}
                            onChange={onInputChange}
                            error={validation.product}
                            required={true}
                            disabled={true}
                          />
                        </Col>

                      </>
                      {/* )} */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Product Type"
                          name="productType"
                          placeholder=""
                          value={formInputs?.productType || ""}
                          onChange={onInputChange}
                          error={validation.productType}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Product Subtype "
                          name="productSubType"
                          placeholder=""
                          value={formInputs?.productSubType || ""}
                          onChange={onInputChange}
                          error={validation.productSubType}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Retail Category"
                          name="retailCategory"
                          placeholder="Name"
                          value={formInputs?.retailCategory || ""}
                          onChange={onInputChange}
                          error={validation.retailCategory}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Product Brands"
                          name="porductBrands"
                          placeholder="Brand"
                          value={formInputs?.porductBrands || ""}
                          onChange={onInputChange}
                          error={validation.porductBrands}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible5 ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PS</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Prices</span>
                      <span className="subHeaderTitle">Prices</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Purchase"
                          name="purchase"
                          placeholder=""
                          value={formInputs?.purchase || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation.purchase}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Inventory"
                          name="inventory"
                          placeholder=""
                          value={formInputs?.inventory || ""}
                          onChange={onInputChange}
                          error={validation.inventory}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Sales "
                          name="sales"
                          placeholder=""
                          value={formInputs?.sales || ""}
                          onChange={onInputChange}
                          error={validation.sales}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Recomended "
                          name="recomended"
                          placeholder=""
                          value={formInputs?.recomended || ""}
                          onChange={onInputChange}
                          error={validation.recomended}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion sri-venkateshwara mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">PD</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">Product Details</span>
                        <span className="subHeaderTitle">Product Details</span>
                      </Col>
                      <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                        
                      </Col>
                    </Row>
                  </h2>
                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                      }`}
                
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            title=""
                            columns={productDetailsCol}
                            data={getProductDetailsData}
                            pagination
                          
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
                <Row className="mt-4">
                  {/* <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                            <button
                              className="btnInfo"
                              onClick={handleSave}
                              // disabled={disable}
                            >
                              Save
                            </button>
                          </Col> */}
                </Row>
              </div>

            </div>

          </Col>
          <Col xs={12} md={3} lg={3} className="d-flex flex-column justify-content-start">
            <div className="sidebarCard p-3 shadow-sm bg-white rounded">
              <h5 className="mb-3">Wash and care</h5>
              <Table bordered size="sm">
                <thead>
                  <tr>
                    <th>Instruction Type</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {washAndCare.instructions.map((item, idx) => (
                    <tr key={idx}>
                      <td>{item.type}</td>
                      <td>{item.description}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {/* Care Icons */}
              <div className="text-center mt-3">
                {washAndCare.icons.map((icon, idx) => (
                  <i key={idx} className={`bi ${icon} me-3`} style={{ fontSize: "34px" }}></i>
                ))}

              </div>
              <div className="text-center">
                <div className="text-center position-relative">
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "332px" }}
                  >

                    {/* {washAndCare.productImages && washAndCare.productImages[currentImg] ? (
                      <img
                        src={washAndCare.productImages[currentImg]}
                        alt={`Product ${currentImg + 1}`}
                        className="img-thumbnail"
                        style={{ maxHeight: "400px", maxWidth: "200px" }}
                      />
                    ) : (
                      <p>No image available</p>
                    )} */}
                     <img
                        src={props?.data?.imageUrl}
                        alt={`Product  `}
                        className="img-thumbnail"
                        style={{ maxHeight: "400px", maxWidth: "200px" }}
                      />


                  </div>
                  
                </div>
              </div>
            </div>
          </Col>
        </Row>
        
        <FailureModal
          show={getShowFailureModal}
          onHide={() => hideFailureModal()}
          // failuremodaldata={getFailureModal}
          requiredfields={getErrorFields}
        />

        {/* </div> */}
        <form className="space-y-4">
          <Row className="justify-end">
            <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
              <button
                type="button"
                onClick={() => props.onHide()}
                className="btn btn-danger mt-4 w-full justify-center rounded-md"
              >
                Cancel
              </button>
            </Col>
            <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
              <button
                type="button"
                // onClick={handleSubmit}
                className="btn btn-primary mt-4 w-full justify-center rounded-md"
              >
                Save
              </button>
            </Col>
            <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
              {/* <p className="errorMsg"> {errorMsg} </p> */}
            </Col>
          </Row>
        </form>
      </Modal.Body>
    </Modal>
  );
});

export default ProductMatrixEditMaterialModal;
